import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth0 } from "@auth0/auth0-react";
import Mashologo from "../../assets/images/Logo for website/Desktop.png";
// Logo from public folder image
const logo_up = "/logo192.png"; 

export default function SignUp() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { loginWithRedirect } = useAuth0();

  const handleGoogleSignup = async () => {
    console.log("Google signup initiated");
    try {
      setLoading(true);
      setError("");

      // Redirect to Auth0 Universal Login with Google connection
      await loginWithRedirect({
        authorizationParams: {
          connection: "google-oauth2",
          prompt: "login", // Force re-authentication
        },
      });
    } catch (error) {
      console.error("Google signup error:", error);
      setError(`Google signup failed: ${error.message}`);
      setLoading(false);
    }
  };

  const handleEmailSignup = async () => {
    try {
      setLoading(true);
      setError("");

      // Redirect to Auth0 Universal Login with signup screen
      await loginWithRedirect({
        authorizationParams: {
          screen_hint: "signup",
          prompt: "login", // Force re-authentication
        },
      });
    } catch (error) {
      console.error("Email signup error:", error);
      setError(`Email signup failed: ${error.message}`);
      setLoading(false);
    }
  };

  const handleExploreWithoutSignIn = () => {
    navigate("/");
  };

  return (
    <>
      <style>
        {`
          @keyframes fadeInUp {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
          .animate-fadeInUp {
            animation: fadeInUp 0.8s ease-out forwards;
          }
        `}
      </style>

      <section className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 space-y-8 animate-fadeInUp">
          <div className="text-center">
            <img
              src={Mashologo}
              alt="MASHO Perfumes Logo"
              className="mx-auto h-16 w-auto mb-4"
            />
            
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Join MASHO Perfumes
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Sign up to explore luxury fragrances
            </p>
            <div className="mt-4 h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
          </div>

          {error && (
            <div className="p-3 bg-red-100 border border-red-400 text-red-700 rounded-md text-sm text-center break-words">
              {error}
            </div>
          )}

          <button
            onClick={handleGoogleSignup}
            disabled={loading}
            className="w-full group relative flex justify-center py-3 px-4 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4AF37] disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-3"
          >
            {loading ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              <>
                <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-1.04.69-2.37 1.1-3.71 1.1-2.85 0-5.27-1.92-6.13-4.5H2.18v2.84C4 20.36 7.68 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.87 14.09c-.22-.66-.34-1.37-.34-2.09s.12-1.43.34-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.69-2.84z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.68 1 4 3.64 2.18 7.07l3.69 2.84c.86-2.58 3.28-4.53 6.13-4.53z"/>
                </svg>
                Sign Up with Google
              </>
            )}
          </button>

          <button
            onClick={handleEmailSignup}
            disabled={loading}
            className="w-full group relative flex justify-center py-3 px-4 border border-gray-300 text-sm font-medium rounded-md text-white bg-[#D4AF37] hover:bg-[#c29e2f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#D4AF37] disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 shadow-md hover:shadow-lg flex items-center justify-center gap-3"
          >
            {loading ? (
              <Loader2 className="h-5 w-5 animate-spin" />
            ) : (
              <>
                <svg className="h-5 w-5" viewBox="0 0 24 24" aria-hidden="true">
                  <path fill="currentColor" d="M12 12c2.21 0 4-1.79 4-4S14.21 4 12 4 8 5.79 8 8s1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
                Sign Up with Email
              </>
            )}
          </button>

          <button
            onClick={handleExploreWithoutSignIn}
            className="w-full mt-4 flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-gray-700 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 transition-all duration-200 shadow-sm"
          >
            Explore Without Signing In
          </button>
        </div>
      </section>
    </>
  );
}